// src/clientLogger.ts
var emptyLogger = {
  error: () => null,
  message: () => null,
  warn: () => null,
  info: () => null,
  trace: () => null
};
var devLogger = {
  error: (err, meta) => {
    console.error(err, meta);
  },
  message: (message, meta) => {
    console.info(message, meta);
  },
  warn: (message, meta) => {
    console.warn(message, meta);
  },
  info: (message, meta) => {
    console.info(message, meta);
  },
  trace: (message, meta) => {
    console.log(`[trace] ${message}`, meta);
  }
};

// src/ClientLoggerContext.tsx
import { createContext, useContext } from "react";
import { jsx } from "react/jsx-runtime";
var ClientLoggerContext = createContext({
  logger: emptyLogger
});
var ClientLoggerProvider = ({
  logger,
  children
}) => {
  return /* @__PURE__ */ jsx(ClientLoggerContext.Provider, { value: { logger: logger ?? emptyLogger }, children });
};
var useClientLogger = () => {
  return useContext(ClientLoggerContext);
};

// src/hooks/useErrorLogger.ts
import { useEffect } from "react";
var useErrorLogger = ({
  error,
  meta,
  callback
}) => {
  const { logger } = useClientLogger();
  useEffect(
    function listenForErrors() {
      if (typeof error !== "undefined") {
        logger.error(error, meta);
        if (callback) {
          callback(error);
        }
      }
    },
    [error]
  );
};
export {
  ClientLoggerProvider,
  devLogger,
  useClientLogger,
  useErrorLogger
};
//# sourceMappingURL=index.mjs.map